import { Button, ButtonProps } from '@mui/material';
import styles from './ExportButton.styles';

interface ExportButtonComponentProps extends ButtonProps {
  onExport: () => void;
}

const ExportButtonComponent = function ({
  onExport,
  variant = 'contained',
  ...rest
}: ExportButtonComponentProps): JSX.Element {
  return (
    <Button onClick={onExport} variant={variant} sx={styles} disableElevation {...rest}>
      Export page
    </Button>
  );
};

export default ExportButtonComponent;
